/* ==========================================================
   Anaya Haram Fabrics — Wishlist Manager
   Stores wishlist product IDs in localStorage, keeps the
   header count badge and all heart buttons in sync across
   the whole site (no app/backend required).
   ========================================================== */
(function () {
  var STORAGE_KEY = 'ah_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function has(id) {
    return getWishlist().indexOf(String(id)) !== -1;
  }

  function add(id) {
    var list = getWishlist();
    id = String(id);
    if (list.indexOf(id) === -1) {
      list.push(id);
      saveWishlist(list);
    }
    refresh();
  }

  function remove(id) {
    var list = getWishlist();
    id = String(id);
    var idx = list.indexOf(id);
    if (idx !== -1) {
      list.splice(idx, 1);
      saveWishlist(list);
    }
    refresh();
  }

  function toggle(id) {
    if (has(id)) {
      remove(id);
      return false;
    }
    add(id);
    return true;
  }

  function updateCountBadges() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-ah-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
  }

  function updateHeartButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      var active = has(id);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.innerHTML = active ? '&#9829;' : '&#9825;';
    });
  }

  function refresh() {
    updateCountBadges();
    updateHeartButtons();
    document.dispatchEvent(
      new CustomEvent('ah:wishlist:update', { detail: { count: getWishlist().length } })
    );
  }

  function bindButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var id = btn.getAttribute('data-product-id');
      if (!id) return;
      toggle(id);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindButtons();
    refresh();
  });

  window.AHWishlist = {
    get: getWishlist,
    add: add,
    remove: remove,
    toggle: toggle,
    has: has,
    refresh: refresh
  };
})();
